import React from 'react';

const Vue_ref_Attribute = () => {
  return (
    <div>
      <h1>Vue_ref_Attribute Component</h1>
      <p>This is the Vue_ref_Attribute tutorial page.</p>
    </div>
  );
}

export default Vue_ref_Attribute;
